import { render } from "./FicaDownloads.vue?vue&type=template&id=3d17edfe&scoped=true"
import script from "./FicaDownloads.vue?vue&type=script&lang=js"
export * from "./FicaDownloads.vue?vue&type=script&lang=js"

import "./FicaDownloads.vue?vue&type=style&index=0&id=3d17edfe&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d17edfe"]])

export default __exports__